import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight, Loader2 } from "lucide-react";
import api from "@/lib/api";

/** Admin → Frontend errors teaser (tab in Admin page) */
export default function AdminFrontendErrorsTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/frontend/errors?hours=72&limit=5");
        setData(data);
      } catch {
        /* access denied silent */
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="grid place-items-center py-10">
        <Loader2 className="w-5 h-5 animate-spin text-rose-500" />
      </div>
    );
  }

  const total = data?.total || 0;
  const top = data?.top || [];
  const healthy = total === 0;

  return (
    <div className="space-y-4" data-testid="admin-errors-tab">
      <div
        className={`rounded-3xl p-6 text-white ${
          healthy ? "bg-gradient-to-br from-emerald-500 to-emerald-700" : "bg-gradient-to-br from-rose-500 to-rose-700"
        }`}
      >
        <div className="flex items-center gap-2 mb-2">
          <AlertTriangle className="w-4 h-4 text-white/80" />
          <p className="text-[10px] font-bold uppercase tracking-widest text-white/80">
            Monitoring · 72 dernières heures
          </p>
        </div>
        <h3 className="font-display text-2xl font-black leading-tight">
          {healthy
            ? "Aucune erreur détectée en prod"
            : `${total} erreur${total > 1 ? "s" : ""} à traiter`}
        </h3>
        <p className="text-sm text-white/75 mt-2 leading-relaxed">
          {healthy
            ? "Votre app tourne proprement. Continuez comme ça."
            : "Prosperr capture automatiquement les erreurs côté utilisateur pour que vous puissiez les corriger avant qu'ils ne les signalent."}
        </p>
        <Link to="/admin/frontend/errors">
          <button
            className="mt-4 bg-[var(--surface)] text-[var(--text)] rounded-full px-5 py-2.5 text-sm font-bold active:scale-[0.99] transition-transform flex items-center gap-2"
            data-testid="open-errors-btn"
          >
            Ouvrir le monitoring
            <ArrowRight className="w-4 h-4" />
          </button>
        </Link>
      </div>

      {top.length > 0 && (
        <div className="bg-[var(--surface)] border border-rose-500/30 rounded-xl p-4">
          <p className="text-[10px] font-bold uppercase tracking-widest text-rose-300 mb-3">Top récurrents</p>
          <div className="space-y-2">
            {top.slice(0, 5).map((t, i) => (
              <div key={i} className="flex items-center gap-3">
                <span className="w-7 h-7 rounded-full bg-rose-500/100 text-white text-xs font-black grid place-items-center shrink-0">
                  {t.count}
                </span>
                <p className="text-sm text-zinc-200 truncate flex-1" title={t.message}>
                  {t.message}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
